import { type CarrierDef } from '../common.js'
import { apiKey, password, username, userPassMap } from '../internal.js'

const credentialTypes = [
  username,
  password,
  apiKey,
  'authentication-key',
] as const

export type valcCredType = (typeof credentialTypes)[number]
export const valc: CarrierDef<valcCredType> = {
  name: 'Valley Cartage',
  scac: 'valc',
  credentialTypes,
  legacyCredMap: [
    ...userPassMap,
    ['api-key', 'apiKey'],
    ['authentication-key', 'ref2'],
  ],
  engineLayers: ['rating', 'pickup', 'tracking'],
  credentialConfig: {
    'authentication-key': { hideFromFreightview: true },
  },
}
